export default __webpack_public_path__ + "static/email-673df73581ef377a255271ce7b5e5efd.svg";